import React, { useState } from "react";
import {
  SubmitButton,
  TextComponent,
  TextHeader,
} from "../../../../components";
import styles from "./RequestedRsvp2.module.css";
import { BiSearchAlt2 } from "react-icons/bi";
import Modal from "../../../../components/modal/Modal";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";

const RequestedRsvp2 = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [Options, setOptions] = useState("");
  const navigate = useNavigate();

  const options = ["Joyfully Accept", "Regretfully Decline"];
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const eventData = useSelector((state) => state.EventReducer.EventDetails);
  const dispatch = useDispatch();

  console.log(RSVP);

  const submit = () => {
    if (!RSVP.family?.[0]?.image?.size) {
      dispatch(
        showAlert({
          title: "createRsvp",
          message: "Please upload images",
          type: "Error",
          status: "error",
        })
      );
      navigate("/events/rsvp/rsvpfamily");
      return;
    }
    dispatch(EventPlanningMiddleware.createRsvp(RSVP))
      .then(() => {
        setIsModalOpen(true);
      })
      .catch();
  };
  return (
    <div>
      <TextHeader
        text={"10. Invite for event "}
        containerClass={styles.textContainer}
      />
      {/* <div className={styles.mainInput}>
        <BiSearchAlt2 className={styles.icon} size={20} />
        <input className={styles.input1} placeholder="Search for guests" />
      </div> */}
      <div className={styles.labelContainer}>
        <TextComponent
          textClass={styles.label}
          text={"Will you be able to Join us at our wedding?"}
        />
        <TextComponent
          textClass={styles.label}
          text={"Please confirm your availability"}
        />
        {options?.map((item, index) => {
          return (
            <div className={styles.btnClass1}>
              <TextComponent text={item} />
            </div>
          );
        })}
        {/* <div className={styles.col}>
          <SubmitButton btnClass={styles.btnClass1} title="Joyfully Accept" />
          <SubmitButton
            btnClass={styles.btnClass1}
            title="Regretfully Decline"
          />
        </div> */}
      </div>
      <SubmitButton
        onClick={() => submit()}
        btnClass={styles.btnClass}
        title="Submit"
      />
      <Modal
        closable
        className={styles.modalContainer}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
      >
        <div className={styles.modal}>
          <TextComponent
            text={"Your request has been sent to RSVPs successfully! "}
            textClass={styles.mainText1}
          />
          <SubmitButton
            btnClass={styles.btnClass2}
            title="Back to guests"
            onClick={() =>
              navigate("/events/eventDetail/guests", { state: { eventData } })
            }
          />
        </div>
      </Modal>
    </div>
  );
};

export default RequestedRsvp2;
